import React from 'react';

interface ITriangleSmall {
    fill: string;
    id?: string;
    width?: number;
    height?: number;
}

const TriangleSmall: React.FC<ITriangleSmall> = ({ fill, id, width, height }) => {
  return (
    <svg width="86" height="37" viewBox="0 0 86 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_11_63" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="37">
    <rect width="2" height="37" fill="black"/>
    <rect x="36" width="2" height="37" fill="black"/>
    <rect x="21" width="2" height="37" fill="black"/>
    <rect x="54" width="2" height="37" fill="black"/>
    <rect x="72" width="2" height="37" fill="black"/>
    <rect x="6" width="2" height="37" fill="black"/>
    <rect x="42" width="2" height="37" fill="black"/>
    <rect x="24" width="2" height="37" fill="black"/>
    <rect x="60" width="2" height="37" fill="black"/>
    <rect x="78" width="2" height="37" fill="black"/>
    <rect x="12" width="2" height="37" fill="black"/>
    <rect x="48" width="2" height="37" fill="black"/>
    <rect x="30" width="2" height="37" fill="black"/>
    <rect x="63" width="2" height="37" fill="black"/>
    <rect x="84" width="2" height="37" fill="black"/>
    </mask>
    <g mask="url(#mask0_11_63)">
    <path d="M43 0L64.6506 37.5H21.3494L43 0Z" id={id} fill={fill}/>
    </g>
    </svg>
  );
};

export default TriangleSmall;
